exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-735d3257&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/PosterSticker.vue
// module id = 576
// module chunks = 0